import {
  OrderDirection,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";

export enum AtsPoMstOrderField {
  CREATED_AT = "CREATED_AT",
  PO_NO = "PO_NO",
  TRN_DATE = "TRN_DATE",
  START_DATE = "START_DATE",
  CLOSE_DATE = "CLOSE_DATE",
}

export interface AtsPoMstOrder {
  direction: OrderDirection;
  field: AtsPoMstOrderField;
}

export enum PoQueryType {
  ALL = "ALL",
  PENDING = "PENDING",
  IN_PROGRES = "IN_PROGRES",
  COMPLETED = "COMPLETED",
}

export interface GetPosVar {
  token?: string;
  queryType: PoQueryType;
  start_date: string;
  end_date: string;
  customerId: number;
  finYrId: number;
  after: string | null;
  orderBy: AtsPoMstOrder;
  name:string
}

export interface AtsPoMst {
  id: number;
  poNo: string;
  poDate: string;
  wrkStartDate: string;
  wrkCloseDate: string;
  raisedByUserID: number;
  itemQty: number;
  totalQty: number;
  totalRate: number;
  totalOther: number;
  totalTaxable: number;
  totalTax: number;
  totalDelvChrg: number;
  totalInstChrg: number;
  totalValue: number;
  remarks: string;
  inProgress: boolean;
  completed: boolean;
  customerID: number;
  finYrID: number;
  ldgrID: number;
  ldgr: {
    desc: string;
  };
}

export interface AtsPoMstEdge {
  node: AtsPoMst;
  cursor: string;
}

export interface AtsPoMstConnection {
  edges: AtsPoMstEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetPosResult {
  GetPos: AtsPoMstConnection;
}
